var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { LinkButton } from "../../molecules/EnrollCard/subcomponents";
var ConfirmChangeButton = function (_a) {
    var availableEnrollmentType = _a.availableEnrollmentType, enrollmentType = _a.enrollmentType, onClick = _a.onClick;
    var t = useTranslation().t;
    if (availableEnrollmentType === "ELECTRONIC" &&
        enrollmentType === "ELECTRONIC_AND_PAPER") {
        return (_jsx(LinkButton, __assign({ buttonType: "text", onClick: onClick, "data-type": "statements", "data-analytics": "clicktrackingevent", "data-reason": "turn off paper statements" }, { children: t("modal.bothEnrolled.turnOffPaper") })));
    }
    if (availableEnrollmentType === "ELECTRONIC_AND_PAPER" &&
        enrollmentType === "ELECTRONIC") {
        return (_jsx(LinkButton, __assign({ buttonType: "text", onClick: onClick, "data-type": "statements", "data-analytics": "clicktrackingevent", "data-reason": "receive paper statements", "data-object": "button" }, { children: t("modal.alreadyEnrolled.paperStatements") })));
    }
    return (_jsx(LinkButton, __assign({ buttonType: "text", onClick: onClick, "data-type": "statements", "data-analytics": "clicktrackingevent", "data-reason": "turn off paperless statements", "data-object": "button" }, { children: t("modal.alreadyEnrolled.link") })));
};
export default ConfirmChangeButton;
